export const environment = {
  botWebsocket: '#BOT_WEBSOCKET#',
  botApi: '#BOT_API#',
  GTM_ID: 'GTM-M5F569C',
};
